import { Transaction } from '../../reducers/admin/allTransactions.slice'
import { Alert, Dialog, List, Text, Button } from '@/ui'
import { filterNulls } from '@/utils/typeHelpers'

export const BulkConfirmTransactionDialog = ({
  open,
  setOpen,
  disabled,
  selectedTransactions,
  onConfirm,
  isSaving,
  error,
}: {
  open: boolean
  setOpen: (open: boolean) => void
  disabled?: boolean
  selectedTransactions: Transaction[]
  onConfirm: () => Promise<void>
  isSaving: boolean
  error?: string
}) => {
  const invalidTransactions = filterNulls(
    selectedTransactions.filter(
      (transaction) =>
        transaction &&
        (!transaction.type || !transaction.transactionCategoryId) &&
        transaction.type !== 'personal'
    )
  )

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Dialog.Trigger>
        <Button onClick={() => setOpen(true)} disabled={disabled}>
          Bulk Confirm
        </Button>
      </Dialog.Trigger>
      <Dialog.Content>
        <Dialog.Header>
          Confirm Transactions: {selectedTransactions.length} transactions
          selected
        </Dialog.Header>

        <Text>🔎 Transactions Check:</Text>
        {invalidTransactions.length === 0 ? (
          <Text>Good job! All transactions are valid.</Text>
        ) : (
          <List>
            {invalidTransactions.map(({ id }) => (
              <List.Item key={id}>Transaction {id} is invalid</List.Item>
            ))}
          </List>
        )}

        <br />
        <Text>
          Please categorize the above categorizations before confirming the
          transactions.
        </Text>
        {error && <Alert variant="error">{error}</Alert>}
        <Dialog.Footer>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            onClick={onConfirm}
            disabled={invalidTransactions.length > 0 || isSaving}
            loading={isSaving}
          >
            Confirm
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
